import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=5ca3abc1"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"
import style0 from "./quotations.vue?vue&type=style&index=0&id=5ca3abc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports